var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEycTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 199,
    viewBox: "0 0 89 199",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2164 159.341C63.8173 112.322 78.8779 66.4823 94.6791 20.8991C97.033 14.1091 101.645 6.31717 107.482 3.07815C112.242 0.436672 123.549 1.5263 126.326 5.20696C130.869 11.2293 134.126 21.633 132.163 28.5549C124.098 56.9997 113.816 84.8138 104.434 112.888C97.1361 134.723 89.8192 156.553 82.7889 178.474C78.7225 191.154 72.471 201.176 57.1531 197.859C44.4719 195.113 40.62 183.446 45.7437 166.811C46.3887 164.718 47.1881 162.671 48.2164 159.341Z",
    fill: "white",
    fillOpacity: 0.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3983 1.12137C26.9093 -0.99655 34.4068 4.55382 38.4698 15.9506C43.0627 28.8342 48.1274 41.5491 52.7827 54.4112C57.2667 66.7998 53.586 76.4506 41.2715 81.0827C28.915 85.7304 21.2339 78.5169 16.8151 67.916C11.3478 54.7998 6.45606 41.4171 1.92949 27.9433C-1.86501 16.6489 1.16121 7.38167 13.3983 1.12137Z",
    fill: "white",
    fillOpacity: 0.22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEycTransparent);
export default __webpack_public_path__ + "static/media/eycTransparent.4121541aa5e9d97e3ab07dfaa1081984.svg";
export { ForwardRef as ReactComponent };